import React, {useEffect} from 'react';
import HeaderSubPage from "./partial/HeaderSubPage";
import {BrowserView, MobileView} from "react-device-detect";
import {customEncodeURIComponent} from "./utils/utils";

const bgImage = process.env.PUBLIC_URL + "/images/headers/reise-title-background.png"

const AllTypes = ({partner, tripTypes}) => {
    useEffect(() => {
        document.title = `${partner?.name} - Unsere Reisearten`;
    }, [partner]);

    return (
        <div>

            <div className="site wrapper-content">
                <HeaderSubPage title={'Reisearten'} subtitle={'Reisearten'} bgImage={bgImage}></HeaderSubPage>
                <section className="content-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8">
                                <header><h1 className=""> Unsere Reisearten </h1></header>
                                <p>Aufgrund der Vielzahl unserer Reisen und Reisethemen haben wir unser Programm
                                    kategorisiert, um Ihnen die Unterschiede noch einfacher darzustellen. Die einzelnen
                                    Kategorien können Sie bequem über den <a
                                        href={`${process.env.PUBLIC_URL}/reisefinder/`}><span
                                        className="color-primary"><strong>Reisefinder</strong></span></a> auswählen.
                                    Somit
                                    bieten wir Ihnen einen schnellen und einfachen Zugang zu Ihrer gewünschten Kategorie
                                    und
                                    Reiseart.</p></div>
                        </div>
                        <div className="clearfix"></div>
                        <MobileView>
                            {tripTypes?.map((post, index) =>
                                <div className="row equal pt-5" key={index}>
                                    <div className="col-md-6  order-md-2 how-img">
                                        <img src={post.image} className="img-fluid" alt={`${partner?.name} - ${post.title}`}  title={`${post.title}`}/>
                                    </div>
                                    <div className="col-md-6 order-md-1"
                                         style={{padding: "30px", backgroundColor: "lightgoldenrodyellow"}}>
                                        <h4>{post.title}</h4>
                                        <p className="text-muted">{post.description}</p>
                                        <p><a
                                            href={`${process.env.PUBLIC_URL}/reisearten/${customEncodeURIComponent(post.title)}/?type=${post.id}`}>Zu
                                            den
                                            Reisen</a>
                                        </p>
                                    </div>
                                </div>
                            )}
                        </MobileView>
                        <BrowserView>
                            {tripTypes?.map((post, index) =>
                                index % 2 === 0 ?
                                    <div className="row equal pt-5" key={index}>
                                        <div className="col-md-6 how-img">
                                            <img src={post.image} className="img-fluid" alt={`${partner?.name} - ${post.title}`} title={`${partner?.name} - ${post.title}`}
                                                 style={{height: "100%"}}/>
                                        </div>
                                        <div className="col-md-6"
                                             style={{padding: "30px", backgroundColor: "lightgoldenrodyellow"}}>
                                            <h4>{post.title}</h4>
                                            <p className="text-muted">{post.description}</p>
                                            <p><a
                                                href={`${process.env.PUBLIC_URL}/reisearten/${customEncodeURIComponent(post.title)}/?type=${post.id}`}>Zu
                                                den
                                                Reisen</a></p>
                                        </div>
                                    </div>
                                    :
                                    <div className="row equal pt-5" key={index}>
                                        <div className="col-md-6"
                                             style={{padding: "30px", backgroundColor: "lightgoldenrodyellow"}}>
                                            <h4>{post.title}</h4>
                                            <p className="text-muted">{post.description}</p>
                                            <p><a
                                                href={`${process.env.PUBLIC_URL}/reisearten/${customEncodeURIComponent(post.title)}/?type=${post.id}`}>Zu
                                                den
                                                Reisen</a></p>
                                        </div>
                                        <div className="col-md-6 how-img">
                                            <img src={post.image} className="img-fluid" alt={`${partner?.name} - ${post.title}`} title={`${post.title}`}
                                                 style={{height: "100%"}}/>
                                        </div>
                                    </div>)}
                        </BrowserView>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default AllTypes;
